'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var InternalCluster = require('../../_chunks/InternalCluster-CI9J3-Do.js');
require('../../_chunks/InternalFlexBox-BDDWEQ9L.js');
require('../../_chunks/combineClasses-5P8GTQkg.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');

/**
 * Use this component to group elements that differ in length, are liable to wrap and need even spacing between them.
 * https://storybook.templafy.com/?path=/docs/layouts-cluster--cluster-of-tags#cluster
 */
const Cluster = react.forwardRef((props, ref) => jsxRuntime.jsx(InternalCluster.InternalCluster, { as: "div", ...props, ref: ref }));
Cluster.displayName = 'Cluster';

exports.Cluster = Cluster;
//# sourceMappingURL=Cluster.js.map
